import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchMultipleForecasts } from '../../predict/src/core/api/forecast';
import { queryClient } from '../core/queryClient';

type FetchMultipleForecastsResult = Awaited<ReturnType<typeof fetchMultipleForecasts>>;
type ForecastsQueryOptions = Omit<QueryObserverOptions<FetchMultipleForecastsResult>, 'queryKey' | 'queryFn'>;

export const forecastsQueryKey = (organisationId: string, workspaceId: string) => [
  'forecasts',
  organisationId,
  workspaceId
];

export const forecastsQuery = (
  workspaceId: string,
  organisationId: string,
  options?: ForecastsQueryOptions
): QueryObserver<FetchMultipleForecastsResult> =>
  new QueryObserver<FetchMultipleForecastsResult>(queryClient, {
    queryKey: forecastsQueryKey(organisationId, workspaceId),
    queryFn: () => fetchMultipleForecasts(workspaceId, organisationId),
    ...options
  });

export const clearForecastsQueryCache = (organisationId: string, workspaceId: string): void => {
  queryClient.invalidateQueries({ queryKey: forecastsQueryKey(organisationId, workspaceId) });
};
